export class PasswordName
{
    static storage: PasswordName = new PasswordName();
    MASTER_KEY(user_id: string)
    {
        return `ns-password-user-${user_id}-master-key`;
    }
    USER(user_id: string)
    {
        return `ns-password-user-${user_id}`;
    }
    RETENTION_DURATION()
    {
        return `ns-password-retention-duration`;
    }
}